// import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/LoginView'

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      alias: '/login',
      name: 'login',
      meta: {
        title: 'ECRMan login'
      },
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: 'ECRMan registrace'
      },
      component: () => import('./views/Register.vue')
    },
    {
      path: '/ecrmregistration',
      name: 'ecrmregistration',
      meta: { auth: [2], title: 'ECRMan pokladny' },
      component: () => import('./views/EcrmRegistration.vue')
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      meta: { auth: [1, 2], title: 'ECRMan změna hesla' },
      component: () => import('./views/ChangePassword.vue')
    },
    {
      path: '/editprofile',
      name: 'editprofile',
      meta: { auth: [2], title: 'ECRMan profil' },
      component: () => import('./views/EditProfile.vue')
    },
    {
      path: '/services_mgmt',
      name: 'services',
      meta: { auth: [2], title: 'ECRMan licence' },
      props: route => ({ query: route.query.id }),
      component: () => import('./views/Services.vue')
    },
    {
      path: '/online_services',
      name: 'online_services',
      meta: { auth: [1,2], title: 'Device mgmt' },
      component: () => import('./views/DevicesMgmt.vue')
    },
    {
      path: '/products',
      name: 'products',
      meta: { auth: [2], title: 'ECRMan produkty' },
      component: () => import('./views/Products.vue')
    },
    {
      path: '/product_list',
      name: 'product_list',
      meta: { title: 'ECRMan produkty' },
      component: () => import('./views/ProductList.vue')
    },
    {
      path: '/dealers_mgmt',
      name: 'dealers_mgmt',
      meta: { auth: [1], title: 'ECRMan dealeři' },
      component: () => import('./views/DealersView.vue')
    },
    {
      path: '/finish_registration',
      name: 'finish_registration',
      meta: {
        title: 'ECRMan registrace'
      },
      props: route => ({ registrationCode: route.query.registrationCode }),
      component: () => import('./views/FinishRegistration.vue')
    },
    {
      path: '/reset',
      name: 'reset',
      meta: {
        title: 'ECRMan obnova hesla'
      },
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '/invoices',
      name: 'invoices',
      meta: {
        title: 'ECRMan faktury'
      },
      component: () => import('./views/InvoicesView.vue')
    },
    {
      path: '/contact',
      beforeEnter() {
        location.href = 'https://www.novumglobal.eu/kontakt/'
      }
    },
    {
      path: '/about',
      beforeEnter() {
        location.href = 'https://www.novumglobal.eu/spolecnost/o-nas/'
      }
    },
    {
      path: '/403',
      component: () => import('./views/ForbiddenComponent.vue')
    },
    {
      path: '*',
      component: () => import('./views/NotFoundComponent.vue')
    }
  ]
})
